/* eslint-disable no-unused-vars */

import 'intersection-observer';
import 'lazysizes';
import 'svgxuse';
import 'flickity';

// Individual Bootstrap components
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/popover';

// Site components
import Navigation from './modules/navigation';
// import PrefetchLinks from './modules/prefetchlinks';
import VideoPlaylist from './modules/videoplaylist';
import Util from './modules/util';
import Maps from './modules/maps';

// Site styles
import '../css/app.scss';

// DOM ready:
$(() => {
	$('html').removeClass('no-js');

	// Init common modules
	// PrefetchLinks.Init();
	Navigation.Init();
	VideoPlaylist.Init();
	Util.Clipboard();

	// Window resized:
	// $(window).on('resize', $.throttle(100, () => { }));
});

// All assets loaded
// $(window).on('load', () => { });
